import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'translateEnum'
})
export class TranslateEnumPipe implements PipeTransform {
    constructor(private translate: TranslateService) {}

    transform(value: string): unknown {
        if (!value) {
            return value;
        }
        const regex = /[A-Z]+[A-Z_]*/g;
        var matches = value.match(regex);
        if (matches != null) {
            for (var m of matches) {
                value = value.replace(m, this.translate.instant(m));
            }
        }
        return value;
    }
}
